import React from "react"
import { Query } from "react-apollo"
import { BreadCrumb, Loading } from "../../../../../../common"
import { DEFAULT_MESSAGES } from "../../../../../../common/config"
import { withForecastContext, ForecastContextInterface } from "../../../../context"
import ListPage from "./ListPage"
import { GET_UNITS_BY_KIND } from "./queries"

const breadCrumbItems = [
  { label: "Editor de demanda", link: "/forecast/demand-editor" },
  { label: "Edición de listas cruzadas", link: null }
]

const Container = (props: any) => {
  return (
    <section className="main-section forecast">
      <div className="hero-body">
        <div className="container is-fluid">
          <BreadCrumb items={breadCrumbItems} />
          <div className="columns">
            <div className="column is-three-quarters">
              <div className="is-content has-background-white">
                <div className="content">{props.content}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

const CLEditorContainer = ({ forecastContext }: { forecastContext?: ForecastContextInterface }) =>
  forecastContext && (
    <Query
      query={GET_UNITS_BY_KIND}
      variables={{ projectId: forecastContext.projectId, kind: "CROSSLIST" }}
    >
      {({ loading, error, data }: any) => {
        if (loading) return <Container content={<Loading />} />
        if (error || data.status.code !== 200)
          return <Container content={<p>{DEFAULT_MESSAGES.ERROR}</p>} />
        return <Container content={<ListPage {...{ list: data.project.unitsByKind }} />} />
      }}
    </Query>
  )

export default withForecastContext(CLEditorContainer)
